/* This file is auto-generated by 'tools/data-lib-gen'. Please don't edit it manually. */
import type { AtreusUser } from '../models/AtreusUser';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as request } from '../core/Request';
import type { RequestConfig } from '../core/Request';

export class UserService {
  /**
   * Show user data
   * @returns atreus_user successful
   * @throws ApiError
   */
  public getAtreusUser(): CancelablePromise<AtreusUser> {
    return request(this.config, {
      method: 'GET',
      url: '/kratos/atreus/user'
    });
  }

  constructor(private config?: RequestConfig) {}
}
